<div
  (mousemove)="allService.effectMouseMove($event)"
  [class.active]="allService._openChatId === chat.id && chat.service_type === allMessengersService.Service.type"
  [contextMenu]="contextMenu"
  [contextMenuSubject]="chat"
  (click)="openChat(chat)"
  [ngClass]="{
              'chat-is-mute': chat.mute_until > 0,
              'chat-is-pinned': chat.is_pinned
            }"
  class="text-reset  p-0 mb-3 position-relative chat-{{ chat?.type }} outline-none"
>

  <div class="card card-active-listener">
              <span
                [style.background-color]="false && chat.type === 'private' ? chat.color : ''"
                class="card-active no-invert"
              ></span>
    <div class="effectMouse card-body p-3" [class.bg-secondary]="chat.unread_messages_count > 0">
      <div class="chat-list-icons">
        <i-feather
          placement="left"
          tooltip="Без&nbsp;звука"
          *ngIf="chat.mute_until > 0"
          name="volume-x"
          class="chat-muted text-muted mr-3"
        ></i-feather>
        <i-feather
          placement="left"
          tooltip="Чат&nbsp;прикреплен"
          *ngIf="chat.is_pinned"
          name="paperclip"
          class="chat-pined text-muted"
        ></i-feather>
      </div>
      <!--<div *ngIf="chat.last_message.out" class="message-read ml-2">
        <i-feather *ngIf="chat.last_message.read" name="check"></i-feather>
        <i-feather name="check"></i-feather>
      </div>-->
      <div class="media">
        <app-avatar
          *ngIf="chat.isSelf; else elseAvatar"
          [id]="chat?.id"
          [type]="'self'"
          class="avatar mr-5"
        ></app-avatar>

        <ng-template #elseAvatar>
          <app-avatar
            [id]="chat?.id"
            [Service]="Service"
            [class.avatar-online]="chat?.online"
            [type]="chat.type"
            [avatar]="chat?.avatar"
            [avatarFileId]="chat?.avatar_file_id"
            [avatarFileUniqueId]="chat?.avatar_file_unique_id"
            [serviceType]="chat?.service_type"
            class="avatar mr-5"
          >

            <div
              *ngIf="(chat.type === 'group' || chat.type === 'supergroup') && chat?.last_message?.avatar"
              class="avatar-sub"
            >
              <app-avatar
                [Service]="Service"
                [class.avatar-online]="chat.last_message?.online"
                [id]="chat.last_message?.from_user?.id"
                [type]="chat.type"
                [avatar]="chat.last_message?.avatar"
                [avatarFileId]="chat.last_message?.avatar_file_id"
                [avatarFileUniqueId]="chat.last_message?.avatar_file_unique_id"
                [serviceType]="chat?.service_type"
                class="message-avatar avatar avatar-xs"
              ></app-avatar>
            </div>
          </app-avatar>
        </ng-template>
        <div class="media-body overflow-hidden">
          <div class="d-flex align-items-center mb-1">
            <h6 *ngIf="chat.isSelf; else elseName" class="text-truncate mb-0 mr-auto">
              <img
                loading="lazy"
                *ngIf="Service.type === 'all'"
                class="title-type {{chat.service_type}}"
                width="30"
                height="30"
                src="/assets/icons/socials/{{ chat.service_type | fixType }}.svg"
                alt="Избранное"/>
              <span>Избранное</span>
            </h6>
            <ng-template #elseName>
              <h6 class="text-truncate mb-0 mr-auto">
                <ng-container [ngSwitch]="chat.ai_chat_mode">
                  <ng-template ngSwitchCase="manager">
                    <i-feather placement="right" tooltip="Ручной режим. Отвечает менеджер" name="users" class="mr-2 invert text-warning"></i-feather>
                  </ng-template>
                  <ng-template ngSwitchDefault>
                    <i-feather placement="right" tooltip="твечает ИИ помошник" name="cpu" class="mr-2 invert text-success"></i-feather>
                  </ng-template>
                </ng-container>
                <i-feather
                  placement="right"
                  tooltip="Подтвржден"
                  *ngIf="chat?.is_verified"
                  name="shield"
                  class="mr-2"
                ></i-feather>

                <ng-template [ngIf]="chat?.name?.first" [ngIfElse]="elseUserName">
                            <span
                              *ngIf="chat?.name?.first; else elseUserName"
                              [innerHTML]="chat?.name?.first + ' ' + chat?.name?.last | replaceEmojis: 'facebook':20:64"
                            ></span>
                </ng-template>
                <ng-template #elseUserName>
                            <span
                              [innerHTML]="
                                chat?.title || chat?.username || 'Удаленный аккаунт' | replaceEmojis: 'facebook':20:64
                              "
                            ></span>
                </ng-template>
              </h6>
            </ng-template>
            <p *ngIf="chat?.last_message?.time && chat?.last_message?.time !== 9999999999999" class="small text-muted text-nowrap ml-4">
              <span class="chat-list-timeago">{{ chat.last_message.time | timeago }}</span>
              <span class="chat-list-time">
                          <ng-template [ngIf]="chat?.name?.first?.length < 8 && chat?.title < 8" [ngIfElse]="shortDate">
                            {{ chat.last_message.time | date: 'H:mm d.MM' }}
                          </ng-template>
                        </span>
              <ng-template #shortDate>
                {{ chat.last_message.time | date: 'd.MM' }}
              </ng-template>
            </p>
          </div>

          <div *ngIf="chat.typing" class="text-truncate">
            печатает<span class="typing-dots"><span>.</span><span>.</span><span>.</span></span>
          </div>
          <div
            *ngIf="chat.last_message && !chat.typing"
            class="text-truncate row flex-nowrap mx-0 text-preview"
            [class.open]="!chat.open"
          >
            <i *ngIf="chat.last_message.out" class="mr-2 col-auto px-0">{{chat.last_message.from_user.id == 'ai_bot' ? 'Ai бот' : 'Менеджер'}}:</i>
            <i
              *ngIf="
                          !chat.last_message.out &&
                          (chat.type === 'group' || chat.type === 'supergroup') &&
                          chat.last_message?.name?.first
                        "
              class="mr-2 col-auto px-0 text-truncate"
              [ngStyle]="{ color: chat.color, 'max-width': '100px' }"
            ><span
              [innerHTML]="chat.last_message?.name?.first + ':' | replaceEmojis: 'facebook':20:64"
            ></span
            ></i>
            <span
              class="col px-0"
              *ngIf="!chat.last_message?.delete; else deleteMessge"
              [innerHTML]="chat.last_message.text_list | replaceEmojis: 'facebook':20:64"
            ></span>
            <ng-template #deleteMessge>
              <small class="text-danger font-italic">Сообщение удалено</small>
            </ng-template>
          </div>
        </div>
      </div>
      <span (click)="contextMenuOpen($event, chat)" class="btn-more">
        <i-feather name="chevron-down" class="icon-lg"></i-feather>
      </span>
    </div>
  </div>

  <div
    placement="left"
    tooltip="Непрочитано"
    *ngIf="chat.unread_messages_count > 0"
    class="badge badge-circle badge-primary badge-border-light badge-top-right"
  >
    <span *ngIf="chat.unread_messages_count < 100000">{{ chat.unread_messages_count }}</span>
  </div>
</div>
